export const MAIN_WAITING_INITIAL_PAYMENT =
  'Ожидание оплаты первоначального взноса';
export const SECONDARY_PAYMENT_STATUS =
  'Если клиент оплатил в банке, нажмите кнопку “Обновить статус”';
export const MAIN_WAITING_VEHICLE_REGISTRATION = 'Ожидание регистрации ТС';
export const MAIN_WAITING_MARRIAGE_DOCUMENTS =
  'Ожидание загрузки документов о браке';
export const MAIN_WAITING_REGISTRATION =
  'Ожидание загрузки документа регистрации залога';
export const MAIN_ON_REWORK = 'Ожидание переотправки документов';
